import Modal from "react-modal";
import styles from "./ModalConfirmarRetirada.module.css";
import {EntrepreneurOrdersType} from "../../types/PedidosPacotesProdutos";
import {useTranslation} from "react-i18next";


Modal.setAppElement('#root');

interface ModalConfirmarRetiradaProps {
  isOpen: boolean; 
  order: EntrepreneurOrdersType | null;
  handleYes: () => void;
  handleCancel: () => void;
}

export default function ModalConfirmarRetirada({
  isOpen,
  order,
  handleYes,
  handleCancel,
}: ModalConfirmarRetiradaProps) {

  const { t } = useTranslation("translation", { keyPrefix: "accountMenu" });

  return (
    <Modal
      isOpen={isOpen}
      className={styles.Modal}
      overlayClassName={styles.Overlay} 
    >
      <div className={styles.containerModal}>
        <h1>{t("confirmPickup")}</h1>
        <div>
          <p>{t("orderPickedUp")} <strong>#{order ? order.id : ''}</strong> {t("inStore")}?</p>
        </div>
        <div className={styles.containerButtons}>
          <button onClick={handleCancel}>{t("cancel")}</button>
          <button onClick={handleYes}>{t("yes")}</button>
        </div>
      </div>
    </Modal>
  );
}
